import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, List, SwipeableDrawer, Backdrop, CircularProgress, IconButton } from "@mui/material";
import { useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { requestInviteParam, usePageTitle, loginRedirectParam, loginHintParam } from '../../logic';
import { DoubleCloudBox } from '../shared';
import { Help } from "../shared/Help";
import { Legalese } from "../shared/Legalese";
import { RequestInvite } from "../shared/RequestInvite";
import CloseIcon from '@mui/icons-material/Close';

export function LandingPage({ drawerHeight }: {
  drawerHeight: number;
}) {
  const { loginWithRedirect } = useAuth0();

  const [searchParams] = useSearchParams();
  const requestInviteInitially = searchParams.has(requestInviteParam)
  const hasLoginRedirect = searchParams.has(loginRedirectParam)
  const loginHint = searchParams.get(loginHintParam) || ''
  const [open, setOpen] = useState(requestInviteInitially);

  usePageTitle('Welcome!');

  if (hasLoginRedirect) {
    loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search },
      login_hint: loginHint,
    });
  }

  function showRequestInvite() {
    setOpen(true);
  }


  function onClick() {
    showRequestInvite()
  }

  return (
    <>
      <Backdrop open={hasLoginRedirect} sx={{ color: "#FFFFFF" }} >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        sx={{
          maxWidth: "400px",
          ml: "auto",
          mr: "auto",
          mt: { xs: 0, sm: `${drawerHeight}px` },
        }}
      >
        <Box
          sx={{
            display: "flex",
            pr: "20px",
            pl: "20px",
            pt: 9,
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              fontSize: "56px",
              lineHeight: "54px",
              fontWeight: 300,
              minWidth: 220,
              pt: { xs: "26px", sm: "44px" },
              marginBottom: "32px",
              marginRight: "10px",
              letterSpacing: "-0.5px",
            }}
          >
            Hello, come right in!
          </Box>
          <DoubleCloudBox></DoubleCloudBox>
        </Box>

        <List
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            mt: 4,
          }}
        >
          <Button
            onClick={onClick}
            variant="contained"
            sx={{
              width: "90%",
              height: "42px",
              boxShadow: "none",
              fontSize: "16px",
              fontWeight: "400",
              bgcolor: "primary.main",
              color: "white",
              border: "none",
              mb: 2,
            }}
          >
            Continue
          </Button>
          <Help />
          <Box sx={{ pt: 1 }}>
            <Legalese></Legalese>
          </Box>
        </List>

        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          sx={{
            ".MuiPaper-root": {
              height: `calc(100% - ${drawerHeight + 5}px)`,
              borderRadius: "30px 30px 0 0",
            },
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              m: `${drawerHeight + 5}px 0`,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
            <RequestInvite />
          </Box>
        </SwipeableDrawer>
      </Box>
    </>
  );
}
